<template>
    <div id="nf-content-top">
        <!-- 顶部搜索组件 -->
        <nf-top-select
            v-if="haveSearch"
            :is-top-row="isTopRow"
            :top-left-text="topLeftText"
            :is-reset-btn="isResetBtn"
            :is-more-search-btn="isMoreSearchBtn"
            :store-model-name="storeModelName"
            :on-handle-reset-btn-click="onHandleResetBtnClick"
            :on-handle-search-btn-click="onHandleSearchBtnClick"
        >
            <div slot="top-title-right">
                <slot name="top-title-right" />
            </div>
            <!-- 顶部默认搜索插槽 -->
            <div slot="default-search">
                <slot name="default-search" />
            </div>
            <!-- 高级搜索插槽 -->
            <div slot="default-search-more">
                <slot name="default-search-more" />
            </div>
        </nf-top-select>
        <!-- 其他模块 -->
        <div slot="other-module">
            <slot name="other-module" />
        </div>
        <nf-table
            :import-url="importUrl"
            :is-export-btn="isExportBtn"
            :on-table-select="onTableSelect"
            :is-table-select="isTableSelect"
            :right-buttons="rightButtons"
            :store-model-name="storeModelName"
            :add-btn-link="addBtnLink"
            :is-edit-table-btn="isEditTableBtn"
            :is-get-list="isGetList"
            :show-summary="showSummary"
            :tree-load-fn="treeLoadFn"
            :is-pagination="isPagination"
            :is-operation-fixed="isOperationFixed"
            :add-btn-link-text="addBtnLinkText"
            :el-table-height="elTableHeight"
        >
            <div slot="top-btn-right">
                <slot name="top-btn-right" />
            </div>

            <div slot="top-btn-left">
                <slot name="top-btn-left" />
            </div>
            
            <div slot="table-foot">
                <slot name="table-foot" />
            </div>

            <!-- 根据tableHeadList slotName字端 动态插入 插槽 -->
            <template
                v-for="(item) in tableHeadListSlotName"
                :slot="item.slotName"
                slot-scope="scope"
            >
                <div
                    :key="item.slotName"
                >
                    <slot
                        :name="item.slotName"
                        :scope="scope.scope"
                    />
                </div>
            </template>
        </nf-table>
    </div>
</template>
<script>

export default {
    name:'NfList',
    props:{
        // 是否显示分页
        isPagination:{
            type:Boolean,
            default:true
        },
        // 是否显示 搜索栏 顶部title 内一栏
        isTopRow:{
            type:Boolean,
            default:true
        },
        // 是否显示搜索栏
        haveSearch:{
            type:Boolean,
            default:true
        },
        // 导入excel地址
        importUrl:{
            type:String,
            default:''
        },
        // 导出excel按钮是否显示
        isExportBtn:{
            type:Boolean,
            default:false
        },
        // 多选回调方法
        onTableSelect:{
            type:Function,
            default:()=>{}
        },
        // 是否显示表格的多选按钮
        isTableSelect:{
            type:Boolean,
            default:false
        },
        // 添加按钮路由路径
        addBtnLink:{
            type:String,
            default:''
        },
        // vuex Model 名称
        storeModelName:{
            type:String,
            required:true,
            default:''
        },
        // 是否显示table操作栏
        rightButtons:{
            type:Array,
            default:()=>[]
        },
        // 是否显示重置按钮
        isResetBtn:{
            type:Boolean,
            default:false
        },
        // 是否显示高级搜索按钮
        isMoreSearchBtn:{
            type:Boolean,
            default:false
        },
        // 是否显示排序
        showSummary:{
            type:Boolean,
            default:false
        },
        // 是否开启编辑表头功能
        isEditTableBtn:{
            type:Boolean,
            default:true
        },
        // nf-table creatd 函数 是否请求列表数据
        isGetList:{
            type:Boolean,
            default:true
        },
        // 组件布局，子组件名用逗号分隔
        paginationLayout:{
            type:String,
            default:'total,sizes, prev, pager, next'
        },
        // 点击分页监听变化
        onHandleCurrentChange:{
            type:[Function,Boolean],
            default:false
        },
        // 点击查询按钮
        onHandleSearchBtnClick:{
            type:[Function,Boolean],
            default:false
        },
        // 表格 当某一行被点击时会触发该事件
        onTableRowClick:{
            type:[Function,Boolean],
            default:false
        },
        // 点击重置按钮触发
        onHandleResetBtnClick:{
            type:[Function,Boolean],
            default:false
        },
        // 操作按钮是否固定在右侧浮动
        isOperationFixed:{
            type:Boolean,
            default:false
        },
        // table的高度
        elTableHeight:{
            type:[Number,String],
            default:0
        },
        // 搜索左上角文字
        topLeftText:{
            type:String,
            default:''
        },
        // 添加按钮文字
        addBtnLinkText:{
            type:String,
            default:'添加'
        },
        treeLoadFn:{
            type:[Function,Boolean],
            default:false
        },
    },
    computed:{
        // 从store里读取列表数据
        tableHeadList (){
            return this.$store.state[this.storeModelName].listData.tableHeadList;
        },
        // 找出带插槽的数据Item
        tableHeadListSlotName(){
            return this.tableHeadList.filter(item=>item.slotName)
        }
    }
}
</script>

